import React from "react";

const CheckMark = ({ color, size = 20, classNames }) => (
  <svg
    className={`icon-checkmark ${color} ${
      classNames ? classNames.join(" ") : ""
    }`}
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M16.5959265,4.46892202 L18.5284672,6.39788933 C18.788406,6.65734756 18.7887957,7.07840209 18.5293374,7.33834095 C18.5290476,7.33863131 18.5287575,7.3389214 18.5284672,7.33921122 L9.28929813,16.5612968 C9.0418462,16.8082911 8.6453928,16.82149 8.38206103,16.5915007 L2.50178449,11.4557724 C2.22516446,11.2141775 2.19677105,10.7940812 2.43836603,10.5174611 C2.43863351,10.5171549 2.43890127,10.5168489 2.43916931,10.5165431 L4.23877131,8.46365798 C4.48055935,8.18783974 4.90001804,8.15987588 5.17627934,8.40115755 L8.19684937,11.0392693 C8.46018114,11.2692586 8.85663455,11.2560598 9.10408647,11.0090654 L15.6563452,4.46892202 C15.9159439,4.20980327 16.3363278,4.20980327 16.5959265,4.46892202 Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default CheckMark;
